<template>
  <b-modal
    id="modal-marcas"
    title="Todas as marcas"
    size="xl"
    ok-title="Salvar"
    cancel-title="Cancelar"
    @hidden="leave"
    @ok="save"
  >
    <div
      v-if="loading"
      class="text-center"
    >
      <b-spinner
        variant="primary"
        type="grow"
        label="Spinning"
      ></b-spinner>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-6">
          <div class="custom-control custom-checkbox my-1 mr-sm-2">
            <input
              @click="selectAll"
              type="checkbox"
              class="custom-control-input"
              id="select-all"
              name="select-all"
            />
            <label
              class="custom-control-label"
              for="select-all"
            >Selecionar Tudo</label>
          </div>
        </div>
        <div class="col-6">
          <b-form-input
            v-model="filter"
            @keyup="filterItems"
            placeholder="Pesquisar Marca"
            size="sm"
          />
        </div>
      </div>
      <hr />
      <div class="row dealers-area mt-4">
        <div class="col-12">
          <div
            v-for="(marca, i) in myMarcas"
            :key="i"
          >
            <div class="custom-control custom-checkbox my-1 mr-sm-2">
              <input
                @click="addMarca($event, marca)"
                type="checkbox"
                class="custom-control-input"
                :value="marca.descricao"
                :id="`${marca.descricao}-${i}`"
                :name="`${marca.descricao}-${i}`"
                :checked="check(marca.marca)"
              />
              <label
                class="custom-control-label"
                :for="`${marca.descricao}-${i}`"
              >{{ marca.descricao }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
// import { mapActions } from 'vuex';
// import { mapFields } from 'vuex-map-fields';
import axios from 'axios';
import EventBus from '../../../eventBus';

const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';

export default {
  props: ['userMarcas', 'userId'],

  data: () => ({
    checked: false,
    filter: null,
    loading: true,
    marcas: [],
    myMarcas: [],
    ids: [],
    userAuth: null,
  }),

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_pbiAssobens'));
  },

  async mounted() {
    await this.carregaMarcas();
    this.loading = false;
  },

  computed: {},

  methods: {

    async carregaMarcas() {
      try {
        const { data } = await axios.get(`${url}/dados/marcas`);
        this.marcas = data;
        this.myMarcas = this.marcas;
        this.userMarcas.forEach((el) => {
          this.ids.push(el.marcaId);
        });
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },

    filterItems() {
      this.myMarcas = this.marcas.filter(
        // eslint-disable-next-line
        (el) => el.descricao.toLowerCase().indexOf(this.filter.toLowerCase()) > -1,
      );
    },

    selectAll(event) {
      this.ids = [];

      if (event.target.checked) {
        this.marcas.forEach((el) => {
          this.ids.push(el.marca);
        });
      }
    },

    addMarca(event, marca) {
      if (event.target.checked) {
        this.ids.push(marca.marca);
      } else {
        const arr = [];

        for (let i = 0; i < this.ids.length; i += 1) {
          // eslint-disable-next-line eqeqeq
          if (!(this.ids[i] == marca.marca)) {
            arr.push(this.ids[i]);
          }
        }
        this.ids = arr;
      }
    },

    check(id) {
      for (let i = 0; i < this.ids.length; i += 1) {
        // eslint-disable-next-line eqeqeq
        if (this.ids[i] == id) return true;
      }
      return false;
    },

    leave() {
      this.checked = false;
      this.filter = null;
      this.ids = [];
      this.myMarcas = this.marcas;

      this.userMarcas.forEach((el) => {
        this.ids.push(el.marca);
      });
    },

    save() {
      EventBus.$emit('saveUserMarcas', this.ids);
      this.checked = false;
      this.filter = null;
      this.ids = [];
      this.myMarcas = this.marcas;
    },
  },
};
</script>

<style scoped>
.dealers-area {
  min-height: 350px;
  max-height: 350px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
